module.exports = __webpack_public_path__ + "img/line_2_1_0.658efe02.png";